import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { FormGroup } from "reactstrap";
import validator from "validator";
import { Block, BlockContent, BlockHead, BlockTitle, Button, Icon, PreviewCard } from "../../components/Component";
import { authHeader } from "../../header";
import LogoDark from "../../images/logo-dark.png";
import Logo from "../../images/logo.png";
import Head from "../../layout/head/Head";
import PageContainer from "../../layout/page-container/PageContainer";
import AuthFooter from "./AuthFooter";

const SetPassword = () => {
  const [passState, setPassState] = useState(false);
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const params = new URLSearchParams(window.location.search)
  const userEmail = params.get('email')
  const [formData, setFormData] = useState({ email: userEmail? userEmail: userInfo?.email, newPassword: "", confirmPassword: "" });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSignout = async () => {
    const data = {};
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/logout`, data, {
        headers: authHeader(),
      });
      const formData = response.data;
      if (formData) {
        localStorage.clear();
        window.location.href = "/auth-login";
      }
    } catch (error) {}
  };

  const resetPassword = async (obj) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/users/reset-password2`, obj, {});
      const formData = await response.data;
      toast.success(formData.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (formData) {
          window.location.href = "/auth-login";
      }
      return { formData };
    } catch (error) {
      const errorMsg = error.response.data.message;
      toast.error(errorMsg, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const setPassword = async (obj) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/users/reset-password`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      toast.success(formData.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
      if (formData) {
          setTimeout(() => {
            handleSignout();
          }, 2000);
      }
      return { formData };
    } catch (error) {
      const errorMsg = error.response.data.message;
      toast.error(errorMsg, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  const checkPassword = (value) => {
    if (
      validator.isStrongPassword(value, {
        minLength: 8,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 1,
      })
    ) {
      if(userEmail){
        resetPassword(formData);
      }else{
        setPassword(formData);
      }
    } else {
      toast.error("Password must contain 8 Characters, 1 Lower Case, 1 Upper Case, 1 Number and 1 Symbol", {
        position: toast.POSITION.TOP_LEFT,
      });
    }
  };

  const changePassword = () => {
    if (formData.confirmPassword !== formData.newPassword) {
      toast.error("Password Must Match", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      checkPassword(formData.newPassword);
    }
  };

  const { errors, register } = useForm();
  return (
    <React.Fragment>
      <Head title="Set-Password" />
      <PageContainer>
        <Block className="nk-block-middle nk-auth-body  wide-xs">
          <div className="brand-logo pb-4 text-center">
            <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
              <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
              <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
            </Link>
          </div>
          <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
            <BlockHead>
              <BlockContent>
                <BlockTitle tag="h5">Set password</BlockTitle>
              </BlockContent>
            </BlockHead>
            <form>
              <FormGroup>
                <div className="form-label-group">
                  <label className="form-label" htmlFor="newPassword">
                    Password
                  </label>
                  {/* <Link className="link link-primary link-sm" to={`${process.env.PUBLIC_URL}/auth-reset`}>
                    Forgot Code?
                  </Link> */}
                </div>
                <div className="form-control-wrap">
                  <a
                    href="#password"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setPassState(!passState);
                    }}
                    className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                  >
                    <Icon name="eye" className="passcode-icon icon-show"></Icon>

                    <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                  </a>
                  <input
                    type={passState ? "text" : "password"}
                    id="newPassword"
                    name="newPassword"
                    onChange={handleChange}
                    // defaultValue="123456"
                    ref={register({ required: "This field is required" })}
                    placeholder="Enter your Password"
                    className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                  />
                  {errors.passcode && <span className="invalid">{errors.passcode.message}</span>}
                </div>
              </FormGroup>

              <FormGroup>
                <div className="form-label-group">
                  <label className="form-label" htmlFor="confirmPassword">
                    Confirm Password
                  </label>
                </div>
                <div className="form-control-wrap">
                  <a
                    href="#password"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setPassState(!passState);
                    }}
                    className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                  >
                    <Icon name="eye" className="passcode-icon icon-show"></Icon>

                    <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                  </a>
                  <input
                    type={passState ? "text" : "password"}
                    id="confirmPassword"
                    name="confirmPassword"
                    onChange={handleChange}
                    // defaultValue="123456"
                    ref={register({ required: "This field is required" })}
                    placeholder="Confirm your Password"
                    className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                  />
                  {errors.passcode && <span className="invalid">{errors.passcode.message}</span>}
                </div>
              </FormGroup>

              <FormGroup>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-block"
                  onClick={(ev) => {
                    ev.preventDefault();
                    changePassword();
                  }}
                >
                  Set Password
                </Button>
              </FormGroup>
            </form>
          </PreviewCard>
        </Block>
        <AuthFooter />
      </PageContainer>
    </React.Fragment>
  );
};
export default SetPassword;
